export const BENEFITS = [
  {
    id: 1,
    title: 'Продавец',
    descr: 'Быстрее продает квартиру за счет выгодных условий по ипотеке',
    imageClass: 'key',
  },
  {
    id: 2,
    title: 'Покупатель',
    descr: 'Экономит до 16% на ежемесячных платежах по кредиту',
    imageClass: 'coin',
  },
  {
    id: 3,
    title: 'Риелтор',
    descr: 'Получает до 25% больше просмотров объявлений и оперативно находит покупателя',
    imageClass: 'laptop',
  },
];
